let initRequests = {
	init: false,
	heartbeat: 0,
	new_member: {submitting: false, member_no: false},
	retrieve_member_no: {submitting: false, sent: false, member_no: false},
	email_retrieve_member: {submitting: false, sent: false},
	email_password_reset: {submitting: false, sent: false},
	password_reset_with_code: {submitting: false, updated: false, message: ''},
	password_reset_with_password: {submitting: false, updated: false, message: ''},
	checkout: {submitting: false, invoice: false, message: ''},
	capture_paypal_payment: {submitting: false, paid: false, message: ''},
	name_badge: {submitting: false, expires: 0, url: false, message: ''},
	course_withdrawal: {submitting: false, sent: false, message: ''},
	undo_course_withdrawal: {submitting: false, sent: false, message: ''},
	login_error: false,
	logout_error: false,
	logo: {submitting: false, image: ''}
};

const requests = (state = initRequests, action) => {
	switch (action.type) {
		case 'INIT_SUCCESS':
			return {...state, init: true }
		case 'LOGIN_SUCCESS':
		case 'USER_SUCCESS':
		case 'HEARTBEAT_SUCCESS':
			return {...state, heartbeat: Math.floor(Date.now() / 1000)}
		case 'LOGIN_FAILURE':
			return {...state, login_error: true}
		case 'RESET_LOGIN_FAILURE':
			return {...state, login_error: false}
		case 'LOGOUT_SUCCESS':
			return {...state, name_badge: {submitting: false, expires: 0, url: false, message: ''}, heartbeat: 0}
		case 'LOGOUT_FAILURE':
			return {...state, logout_error: true}
		case 'RESET_LOGOUT_FAILURE':
			return {...state, logout_error: false}
		case 'RESET_ERROR_MESSAGE':
			return {...state, checkout: {submitting: false, invoice: false, message: ''}}
		case 'CHECKOUT_REQUEST':
			return {...state, checkout: {submitting: true, invoice: false, message: ''}}
		case 'CHECKOUT_SUCCESS':
			return {...state, checkout: {submitting: false, invoice: action.response.invoice_no, message: ''}}
		case 'CHECKOUT_FAILURE':
			return {...state, checkout: {submitting: false, invoice: false, message: action.error}}
		case 'PP_CAPTURE_REQUEST':
			return {...state, capture_paypal_payment: {submitting: true, paid: false, message: ''}}
		case 'PP_CAPTURE_SUCCESS':
			return {...state, capture_paypal_payment: {submitting: true, paid: true, message: ''}}
		case 'PP_CAPTURE_FAILURE':
			return {...state, capture_paypal_payment: {submitting: false, paid: false, message: action.error}}
		case 'NEW_MEMBER_REQUEST':
			return {...state, new_member: {submitting: true, member_no: false}}
		case 'NEW_MEMBER_SUCCESS':
			return {...state, new_member: {submitting: false, member_no: action.response.member_no}}
		case 'NEW_MEMBER_FAILURE':
			return {...state, new_member: {submitting: false, member_no: false}}
		case 'PASSWORD_RESET_EMAIL_REQUEST':
			return {...state, email_password_reset: {submitting: true, sent: false}}
		case 'PASSWORD_RESET_EMAIL_SUCCESS':
			return {...state, email_password_reset: {submitting: false, sent: true}}
		case 'PASSWORD_RESET_EMAIL_FAILURE':
			return {...state, email_password_reset: {submitting: false, sent: false}}
		case 'PASSWORD_RESET_CODE_REQUEST':
			return {...state, password_reset_with_code: {submitting: true, updated: false, message: ''}}
		case 'PASSWORD_RESET_CODE_SUCCESS':
			return {...state, password_reset_with_code: {submitting: false, updated: true, message: ''}}
		case 'PASSWORD_RESET_CODE_FAILURE':
			return {...state, password_reset_with_code: {submitting: false, updated: false, message: action.error}}
		case 'UPDATE_PASSWORD_REQUEST':
			return {...state, password_reset_with_password: {submitting: true, updated: false, message: ''}}
		case 'UPDATE_PASSWORD_SUCCESS':
			return {...state, password_reset_with_password: {submitting: false, updated: true, message: ''}}
		case 'UPDATE_PASSWORD_FAILURE':
			return {...state, password_reset_with_password: {submitting: false, updated: false, message: action.error}}
		case 'RETRIEVE_MEMBER_NO_REQUEST':
			return {...state, retrieve_member_no: {submitting: true, member_no: false}}
		case 'RETRIEVE_MEMBER_NO_SUCCESS':
			return {...state, retrieve_member_no: {submitting: false, member_no: action.response.member_no}}
		case 'RETRIEVE_MEMBER_NO_FAILURE':
			return {...state, retrieve_member_no: {submitting: false, member_no: false}}
		case 'RETRIEVE_MEMBER_EMAIL_REQUEST':
			return {...state, email_retrieve_member: {submitting: true, sent: false}}
		case 'RETRIEVE_MEMBER_EMAIL_SUCCESS':
			return {...state, email_retrieve_member: {submitting: false, sent: true}}
		case 'RETRIEVE_MEMBER_EMAIL_FAILURE':
			return {...state, email_retrieve_member: {submitting: false, sent: false}}
		case 'LOGO_REQUEST':
			return {...state, logo: {submitting: true, image: ''}}
		case 'LOGO_SUCCESS':
			return {...state, logo: {submitting: false, image: action.response.logo}}
		case 'LOGO_FAILURE':
			return {...state, logo: {submitting: false, image: ''}}
		case 'NAME_BADGE_REQUEST':
			return {...state, name_badge: {submitting: true, expires: 0, url: false, message: ''}}
		case 'NAME_BADGE_SUCCESS':
			const exp = Math.floor(Date.now() / 1000) + 300; // current time + 5 minutes
			return {...state, name_badge: {submitting: false, expires: exp, url: action.response.url, message: ''}}
		case 'NAME_BADGE_FAILURE':
			return {...state, name_badge: {submitting: false, expires: 0, url: false, message: action.error}}
		case 'COURSE_WITHDRAWAL_REQUEST':
			return {...state, course_withdrawal: {submitting: true, sent: false, message: ''}}
		case 'COURSE_WITHDRAWAL_SUCCESS':
			return {...state, course_withdrawal: {submitting: false, sent: true, message: ''}}
		case 'COURSE_WITHDRAWAL_FAILURE':
			return {...state, course_withdrawal: {submitting: false, sent: false, message: action.error}}
		case 'UNDO_WITHDRAWAL_REQUEST':
			return {...state, undo_course_withdrawal: {submitting: true, sent: false, message: ''}}
		case 'UNDO_WITHDRAWAL_SUCCESS':
			return {...state, undo_course_withdrawal: {submitting: false, sent: true, message: ''}}
		case 'UNDO_WITHDRAWAL_FAILURE':
			return {...state, undo_course_withdrawal: {submitting: false, sent: false, message: action.error}}
		default:
			return state;
	}

}

export default requests
